import { errors } from '@yola/ws-sdk';
import errorModule from 'src/js/modules/error';
import user from 'yola-editor/src/js/modules/user';

const { SITE_BELONGS_TO_ANOTHER_USER } = errorModule.constants;

const onYolaCookieChange = (cookie) => {
  const userData = user.accessors.getUserData();
  let yolaCookie = cookie;

  try {
    yolaCookie = JSON.parse(yolaCookie);
  } catch {
    console.error('Failed to parse yola cookie');
  }

  const decodedYolaCookie = atob(yolaCookie);

  // to prevent error `site belongs to another user` we need to check if the `userId` is't changed in the cookie
  // see error details here (https://github.com/yola/production/issues/15860)
  if (!decodedYolaCookie.includes(userData.id)) {
    errors.operations.catchError(new Error(SITE_BELONGS_TO_ANOTHER_USER));
  }
};

export default onYolaCookieChange;
